import { resolveComponent as _resolveComponent, createVNode as _createVNode, resolveDirective as _resolveDirective, createElementVNode as _createElementVNode, withDirectives as _withDirectives, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, withCtx as _withCtx, createTextVNode as _createTextVNode, createBlock as _createBlock, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-36f9f62e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "d-flex justify-content-between flex-wrap my-1" }
const _hoisted_2 = {
  key: 0,
  class: "d-flex align-items-center"
}
const _hoisted_3 = ["alt"]
const _hoisted_4 = { class: "d-flex flex-column justify-content-between" }
const _hoisted_5 = { class: "text-muted lead mb-0" }
const _hoisted_6 = {
  key: 0,
  class: ""
}
const _hoisted_7 = { class: "d-flex flex-column col-lg-6" }
const _hoisted_8 = { class: "d-flex text-muted" }
const _hoisted_9 = { class: "lead mr-1 flex-grow-1 flex-shrink-0" }
const _hoisted_10 = { key: 0 }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "pi pi-exclamation-circle" }, null, -1))
const _hoisted_12 = {
  key: 0,
  class: "text-muted d-flex align-items-center flex-wrap flex-lg-nowrap"
}
const _hoisted_13 = { class: "lead mr-1 flex-grow-1 flex-shrink-0" }
const _hoisted_14 = { class: "d-flex align-items-center" }
const _hoisted_15 = ["title"]
const _hoisted_16 = ["href"]
const _hoisted_17 = { class: "d-flex justify-content-between flex-grow-1 flex-wrap" }
const _hoisted_18 = { class: "d-flex flex-column" }
const _hoisted_19 = { class: "mb-1" }
const _hoisted_20 = { class: "ml-auto col-md-6 col-xl-4 p-0" }
const _hoisted_21 = { class: "p-input-icon-left w-100" }
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "pi pi-search" }, null, -1))
const _hoisted_23 = {
  key: 0,
  class: "text-danger d-flex flex-nowrap"
}
const _hoisted_24 = { class: "mr-1" }
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "pi pi-exclamation-circle" }, null, -1))
const _hoisted_26 = { key: 1 }
const _hoisted_27 = {
  key: 0,
  class: "d-flex justify-content-lg-end justify-content-between w-100"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_BackButton = _resolveComponent("BackButton")!
  const _component_Button = _resolveComponent("Button")!
  const _component_PopoverIcon = _resolveComponent("PopoverIcon")!
  const _component_Inplace = _resolveComponent("Inplace")!
  const _component_i18n_t = _resolveComponent("i18n-t")!
  const _component_Message = _resolveComponent("Message")!
  const _component_InputText = _resolveComponent("InputText")!
  const _component_Column = _resolveComponent("Column")!
  const _component_DataTable = _resolveComponent("DataTable")!
  const _component_Panel = _resolveComponent("Panel")!
  const _component_LicenceFormModal = _resolveComponent("LicenceFormModal")!
  const _directive_lazy = _resolveDirective("lazy")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_BackButton, {
      label: _ctx.$t('myCadac.licenceManagementDetail.button.back'),
      onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.onBackClick()))
    }, null, 8, ["label"]),
    _createElementVNode("div", _hoisted_1, [
      (_ctx.selectedLicenceProduct)
        ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
            _withDirectives(_createElementVNode("img", {
              alt: _ctx.selectedLicenceProduct?.productName,
              class: "mr-2 align-self-start",
              height: "67",
              width: "67"
            }, null, 8, _hoisted_3), [
              [_directive_lazy, _ctx.selectedLicenceProduct?.productIconUrl]
            ]),
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("p", _hoisted_5, _toDisplayString(_ctx.selectedLicenceProduct?.productBrand), 1),
              (_ctx.selectedLicenceProduct?.productName)
                ? (_openBlock(), _createElementBlock("h1", _hoisted_6, _toDisplayString(_ctx.selectedLicenceProduct?.productName), 1))
                : _createCommentVNode("", true)
            ])
          ]))
        : _createCommentVNode("", true),
      _createElementVNode("div", null, [
        _createVNode(_component_Button, {
          class: "p-button-success p-button-raised p-button-arrow mr-1 flex-shrink-0",
          label: _ctx.$t('myCadac.licenceManagementDetail.button.buyLicences'),
          onClick: _cache[1] || (_cache[1] = ($event: any) => {
					_ctx.openUrl(_ctx.selectedLicenceProduct?.productPageUrl);
					$event.target.disabled = true;
				})
        }, null, 8, ["label"])
      ])
    ]),
    _createElementVNode("div", _hoisted_7, [
      _createElementVNode("div", _hoisted_8, [
        _createElementVNode("span", _hoisted_9, _toDisplayString(_ctx.$t("myCadac.licenceManagementDetail.lblNumberOfLicences")), 1),
        _createElementVNode("b", {
          class: _normalizeClass(["mx-1 text-bold text-black", { 'text-danger': !_ctx.hasAvailableLicences }])
        }, _toDisplayString(_ctx.selectedLicenceProduct?.totalActiveLicences) + " / " + _toDisplayString(_ctx.selectedLicenceProduct?.totalSeats), 3),
        (!_ctx.hasAvailableLicences)
          ? (_openBlock(), _createElementBlock("span", _hoisted_10, [
              _createVNode(_component_PopoverIcon, {
                class: "d-inline-flex text-danger",
                placement: "right",
                style: {"line-height":"1.75rem"}
              }, {
                content: _withCtx(() => [
                  _createElementVNode("p", null, _toDisplayString(_ctx.$t("myCadac.licenceManagementDetail.licenceLimitReached")), 1)
                ]),
                default: _withCtx(() => [
                  _hoisted_11
                ]),
                _: 1
              })
            ]))
          : _createCommentVNode("", true)
      ]),
      (_ctx.selectedLicenceProduct?.applicationKeyAllowed && _ctx.selectedLicenceProduct?.applicationKey)
        ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
            _createElementVNode("span", _hoisted_13, _toDisplayString(_ctx.$t("myCadac.licenceManagementDetail.lblApplicationKey")), 1),
            _createVNode(_component_Inplace, { closable: false }, {
              display: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.$t("myCadac.licenceManagementDetail.lblShowApplicationKey")), 1)
              ]),
              content: _withCtx(() => [
                _createElementVNode("div", _hoisted_14, [
                  _createElementVNode("p", {
                    class: "m-0 limit-line-width text-truncate text-bold text-black",
                    title: _ctx.selectedLicenceProduct?.applicationKey
                  }, _toDisplayString(_ctx.selectedLicenceProduct?.applicationKey), 9, _hoisted_15),
                  _createVNode(_component_Button, {
                    class: "p-button-outlined p-button-secondary copy-button",
                    icon: "pi pi-copy",
                    onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.copyTextToClipboard(_ctx.selectedLicenceProduct?.applicationKey)))
                  })
                ])
              ]),
              _: 1
            })
          ]))
        : _createCommentVNode("", true)
    ]),
    (!_ctx.hasAvailableLicences && _ctx.vm.licenceOveruseAllowed)
      ? (_openBlock(), _createBlock(_component_Message, {
          key: 0,
          closable: false,
          icon: "pi pi-exclamation-triangle",
          severity: "error"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_i18n_t, { keypath: "myCadac.licenceManagementDetail.message.overUsageAllowed" }, {
              link: _withCtx(() => [
                _createElementVNode("a", {
                  href: _ctx.overuseSupportUrl,
                  target: "_blank"
                }, _toDisplayString(_ctx.$t("myCadac.licenceManagementDetail.message.overUsageAllowed_linkText")), 9, _hoisted_16)
              ]),
              _: 1
            })
          ]),
          _: 1
        }))
      : _createCommentVNode("", true),
    _createVNode(_component_Panel, {
      id: "panel-licences",
      class: "my-3",
      toggleable: false
    }, {
      header: _withCtx(() => [
        _createElementVNode("div", _hoisted_17, [
          _createElementVNode("div", _hoisted_18, [
            _createElementVNode("h3", _hoisted_19, _toDisplayString(_ctx.$t("myCadac.licenceManagementDetail.panel.titleLicences")), 1)
          ]),
          (_ctx.hasAvailableLicences || _ctx.vm.licenceOveruseAllowed)
            ? (_openBlock(), _createBlock(_component_Button, {
                key: 0,
                class: "p-button-primary mr-lg-1 ml-0 flex-shrink-0",
                icon: "pi pi-plus",
                label: _ctx.$t('myCadac.licenceManagementDetail.button.addLicence'),
                onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.onAddLicenceClick()))
              }, null, 8, ["label"]))
            : _createCommentVNode("", true)
        ])
      ]),
      default: _withCtx(() => [
        _createVNode(_component_DataTable, {
          filters: _ctx.licenceFilters,
          "onUpdate:filters": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.licenceFilters) = $event)),
          "auto-layout": "",
          "data-key": "id",
          "global-filter-fields": ['fullName', 'name', 'email'],
          paginator: _ctx.showPagination,
          "removable-sort": "",
          "responsive-layout": "stack",
          "row-class": _ctx.getRowClass,
          rows: _ctx.maxRowsToShow,
          value: _ctx.allLicences
        }, {
          empty: _withCtx(() => [
            (!_ctx.allLicences?.length)
              ? (_openBlock(), _createBlock(_component_Message, {
                  key: 0,
                  class: "my-0",
                  closable: false,
                  severity: "warn"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.$t("myCadac.licenceManagementDetail.message.noLicences")), 1)
                  ]),
                  _: 1
                }))
              : (_ctx.licenceFilters['global'].value)
                ? (_openBlock(), _createBlock(_component_Message, {
                    key: 1,
                    class: "my-0",
                    closable: false,
                    severity: "warn"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.$t("myCadac.licenceManagementDetail.message.noLicencesFound", [
							_ctx.licenceFilters["global"].value,
						])), 1)
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true)
          ]),
          header: _withCtx(() => [
            _createElementVNode("div", _hoisted_20, [
              _createElementVNode("span", _hoisted_21, [
                _hoisted_22,
                _createVNode(_component_InputText, {
                  modelValue: _ctx.licenceFilters['global'].value,
                  "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.licenceFilters['global'].value) = $event)),
                  placeholder: _ctx.$t('myCadac.licenceManagementDetail.table.searchLicence_placeholder')
                }, null, 8, ["modelValue", "placeholder"])
              ])
            ])
          ]),
          default: _withCtx(() => [
            _createVNode(_component_Column, {
              key: "displayName",
              field: "displayName",
              header: _ctx.$t('myCadac.licenceManagementDetail.table.colName'),
              sortable: true
            }, null, 8, ["header"]),
            _createVNode(_component_Column, {
              key: "email",
              field: "email",
              header: _ctx.$t('myCadac.licenceManagementDetail.table.colEmail'),
              sortable: true
            }, null, 8, ["header"]),
            _createVNode(_component_Column, {
              key: "roles",
              header: _ctx.$t('myCadac.licenceManagementDetail.table.colRoles')
            }, {
              body: _withCtx((item) => [
                _createElementVNode("span", null, _toDisplayString(_ctx.getRoleDescriptions(item.data).join(",")), 1)
              ]),
              _: 1
            }, 8, ["header"]),
            _createVNode(_component_Column, {
              key: "licenceType",
              field: "licenceType",
              header: _ctx.$t('myCadac.licenceManagementDetail.table.colType'),
              sortable: true
            }, {
              body: _withCtx((item) => [
                _createElementVNode("span", null, _toDisplayString(_ctx.$t(`enum.licenceType.${item.data.licenceType}`)), 1)
              ]),
              _: 1
            }, 8, ["header"]),
            _createVNode(_component_Column, {
              key: "endDate",
              field: "endDate",
              header: _ctx.$t('myCadac.licenceManagementDetail.table.colDate'),
              sortable: true
            }, {
              body: _withCtx((item) => [
                (_ctx.shouldShowContractExpirationWarning(item.data))
                  ? (_openBlock(), _createElementBlock("div", _hoisted_23, [
                      _createElementVNode("span", _hoisted_24, _toDisplayString(_ctx.formatDate(_ctx.getContractExpirationDate(item.data))), 1),
                      _createVNode(_component_PopoverIcon, {
                        class: "d-inline-flex",
                        style: {"line-height":"1.75rem"}
                      }, {
                        content: _withCtx(() => [
                          _createElementVNode("p", null, _toDisplayString(_ctx.$tc("myCadac.contractOverview.table.contractExpirationWarning", {
											count: _ctx.getRemainingContractDays(item.data),
										})), 1)
                        ]),
                        default: _withCtx(() => [
                          _hoisted_25
                        ]),
                        _: 2
                      }, 1024)
                    ]))
                  : (_openBlock(), _createElementBlock("span", _hoisted_26, _toDisplayString(_ctx.formatDate(_ctx.getContractExpirationDate(item.data))), 1))
              ]),
              _: 1
            }, 8, ["header"]),
            _createVNode(_component_Column, { key: "actions" }, {
              body: _withCtx((item) => [
                (!_ctx.shouldShowPendingDeletionWarning(item.data))
                  ? (_openBlock(), _createElementBlock("div", _hoisted_27, [
                      _createVNode(_component_Button, {
                        class: "p-button-primary p-button-icon p-button-rounded p-button-raised p-button-text flex-shrink-0",
                        icon: "pi pi-pencil",
                        label: _ctx.isSmallScreen ? _ctx.$t('common.edit') : '',
                        title: _ctx.$t('common.edit'),
                        onClick: ($event: any) => (_ctx.onEditLicenceClick(item.data))
                      }, null, 8, ["label", "title", "onClick"]),
                      _createVNode(_component_Button, {
                        class: "p-button-danger p-button-icon p-button-rounded p-button-raised p-button-text flex-shrink-0 ml-1",
                        icon: "pi pi-trash",
                        label: _ctx.isSmallScreen ? _ctx.$t('common.remove') : '',
                        title: _ctx.$t('common.remove'),
                        onClick: ($event: any) => (_ctx.onDeleteLicenceClick(item.data))
                      }, null, 8, ["label", "title", "onClick"])
                    ]))
                  : (_openBlock(), _createElementBlock("div", {
                      key: 1,
                      class: _normalizeClass(["text-warning lg-end w-100", { 'warning-message': !_ctx.isSmallScreen }])
                    }, _toDisplayString(_ctx.$t("myCadac.licenceManagementDetail.table.pendingDeletionWarning")), 3))
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["filters", "paginator", "row-class", "rows", "value"])
      ]),
      _: 1
    }),
    (_ctx.licenceStore.isLicenceFormModalVisible)
      ? (_openBlock(), _createBlock(_component_LicenceFormModal, {
          key: 1,
          vm: _ctx.vm,
          onLicenceSaved: _cache[6] || (_cache[6] = ($event: any) => (_ctx.onLicenceSaved($event)))
        }, null, 8, ["vm"]))
      : _createCommentVNode("", true)
  ], 64))
}